export const DRM_SERVER_NAME = {
    playready: 'com.microsoft.playready',
    widevine: 'com.widevine.alpha',
    fairPlay: 'com.apple.fps.1_0',
} as const;
